import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import updateProgressSlice from "./updateProgressSlice";

export const UpdateProgressContext = React.createContext(null);

const UpdateProgressStore = configureStore({
    reducer: {
        updateProgressStore: updateProgressSlice,
    },
});
export default UpdateProgressStore;

export type State = ReturnType<typeof UpdateProgressStore.getState>;
export type Dispatch = typeof UpdateProgressStore.dispatch;
export const useUpdateProgressSelector: TypedUseSelectorHook<State> = createSelectorHook(UpdateProgressContext);
export const useUpdateProgressDispatch = createDispatchHook<Dispatch>(UpdateProgressContext);
